<template>
    <span v-if="pteMode == 'ptea' && type.is_ptea && !type.is_ptec" class="color-primary">
        (PTEA)</span>
    <span v-else-if="pteMode == 'ptec' && type.is_ptec && !type.is_ptea" class="color-primary">
        (Core)</span>

</template>

<script>
export default {
    name: "coreLabel",
    props: {
        type: {
            type: Object,
            default: () => { }
        }
    },

    computed: {
        pteMode: function () {
            return this.$store.state.pteMode
        },
    },
    methods: {
    },
};
</script>
<style>
.core-dialog {
    border-radius: 10px;
    top: 10px;
}
</style>
<style scoped>
.tag {
    color: #999;
    text-align: center;
    line-height: 20px;
    padding: 5px 15px;
    display: inline-block;
    border-radius: 15px;
    border: 1px solid #999;
}

.tag.item {
    width: 50px;
}

.tag.active {
    color: #f66;
    border: 1px solid #f66;
}

.tag.hover:hover {
    border: 1px solid #f66;
    background-color: #f66;
    color: #fff;
}
</style>